import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { setIsSessionInfoOpen } from "../../../../reducers/common-reducer";

const SessionInfo = () => {
    const dispatch = useDispatch();

    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();
    const { callDuration, isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);
    const handleShowSessionInfo = () => {
        dispatch(setIsSessionInfoOpen(true));
    };

    return (
        <div className='topbar-button topbar-session-info'>
            <div className='button custom-tooltip right-tooltip tooltip-auto-width'>
                <button className='btn topbar-btn open-info-sidebar-button' onClick={handleShowSessionInfo}>
                    <span className='for-icon icon-info-stroke'></span>
                    {isRemoteParticipantJoined && <span className='call-timer-text'>{callDuration}</span>}
                </button>
                <div className='custom-tooltip-content text-nowrap'>
                    <div className='custom-tooltip-in'>
                        <p>{localisedValues["click_to_open_more_information"]}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SessionInfo;
